var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/icons/icon-cart.svg": "1dc5",
	"./assets/icons/icon-close.svg": "3324",
	"./assets/icons/icon-delete.svg": "273b",
	"./assets/icons/icon-menu.svg": "2cf5",
	"./assets/icons/icon-minus.svg": "a866",
	"./assets/icons/icon-next.svg": "92ea",
	"./assets/icons/icon-plus.svg": "a3b7",
	"./assets/icons/icon-previous.svg": "7a64",
	"./assets/icons/logo.svg": "5b1c",
	"./assets/images/image-avatar.png": "b10a",
	"./assets/images/image-product-1-thumbnail.jpg": "8aca",
	"./assets/images/image-product-1.jpg": "08c3",
	"./assets/images/image-product-2-thumbnail.jpg": "8f55",
	"./assets/images/image-product-2.jpg": "ca5b",
	"./assets/images/image-product-3-thumbnail.jpg": "eef8",
	"./assets/images/image-product-3.jpg": "8611",
	"./assets/images/image-product-4-thumbnail.jpg": "0ceb",
	"./assets/images/image-product-4.jpg": "dedb",
	"./assets/images/logo.png": "9d64",
	"./assets/styles/abstracts/_colors.scss": "8f5a",
	"./assets/styles/abstracts/_mixins.scss": "3871",
	"./assets/styles/components/_buttons.scss": "2b19",
	"./assets/styles/layouts/_header.scss": "9f24",
	"./assets/styles/layouts/_visualizer.scss": "ef50",
	"./assets/styles/pages/_product.scss": "9e59",
	"./components/Header": "0418",
	"./components/Header.vue": "0418",
	"./components/Visualizer": "9a9e",
	"./components/Visualizer.vue": "9a9e",
	"./main": "56d7",
	"./main.js": "56d7",
	"./pages/Home": "bc13",
	"./pages/Home.vue": "bc13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";